import { PropsWithChildren, createContext, useState } from 'react'

const CURRENT_YEAR = new Date().getFullYear()

export enum LandReportMapDataLayer {
  ACRES = 'acres',
  PERFORMANCE = 'stability',
  SOIL = 'soil',
  ELEVATION = 'elevation',
}
export interface LandReportViewState {
  dataLayer: LandReportMapDataLayer
  focusYear: number
  setDataLayer: (dataLayer: LandReportMapDataLayer) => void
  setFocusYear: (year: number) => void
}

export const LandReportViewContext = createContext<LandReportViewState>({
  dataLayer: LandReportMapDataLayer.ACRES,
  focusYear: 0,
  setDataLayer: console.log,
  setFocusYear: console.log,
})
LandReportViewContext.displayName = 'LandReportViewContext'

export const LandReportViewProvider = ({ children }: PropsWithChildren<object>) => {
  const [focusYear, setFocusYear] = useState<number>(CURRENT_YEAR)
  const [dataLayer, setDataLayer] = useState<LandReportMapDataLayer>(LandReportMapDataLayer.ACRES)

  return (
    <LandReportViewContext.Provider
      value={{
        dataLayer,
        focusYear,
        setDataLayer,
        setFocusYear,
      }}
    >
      {children}
    </LandReportViewContext.Provider>
  )
}
